module.exports = __webpack_public_path__ + "img/ic_thank_you.c8674e30.svg";